"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liquidityTypeEnumArray = exports.LiquidityTypeEnum = void 0;
var LiquidityTypeEnum;
(function (LiquidityTypeEnum) {
    LiquidityTypeEnum["ACTUAL"] = "ACTUAL";
    LiquidityTypeEnum["FORECAST"] = "FORECAST";
})(LiquidityTypeEnum || (exports.LiquidityTypeEnum = LiquidityTypeEnum = {}));
exports.liquidityTypeEnumArray = Object.values(LiquidityTypeEnum);
